'use client';
import React, { useCallback, useState } from 'react';
import { AuthModal } from './AuthModal';
import { AuthIterationType } from './AuthIterations/types';
import { Authentication, AuthMode, RequestAuthEvent } from '@benzinga/session';
import Hooks from '@benzinga/hooks';
import { AuthenticationManager } from '@benzinga/session';
import { SessionContext } from '@benzinga/session-context';
import { SafeType } from '@benzinga/safe-await';

export type AuthPortalProps = AuthIterationType;

export const AuthPortal = ({ onLogin, onRegister, onSessionLoad }: AuthPortalProps) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [authMode, setAuthMode] = useState<AuthMode>('login');
  const session = React.useContext(SessionContext);

  const handleSessionLoad = useCallback(
    (auth: SafeType<Authentication>): void => {
      onSessionLoad && onSessionLoad(auth);
    },
    [onSessionLoad],
  );

  const openModal = useCallback((mode: AuthMode): void => {
    setAuthMode(mode);
    setModalIsOpen(true);
  }, []);

  const closeModal = useCallback((): void => {
    setModalIsOpen(false);
  }, []);

  const handleLogin = useCallback(
    (auth: SafeType<Authentication>): void => {
      setModalIsOpen(false);
      onLogin && onLogin(auth, '');
    },
    [onLogin],
  );

  const handleRegister = useCallback(
    (auth: SafeType<Authentication>): void => {
      setModalIsOpen(false);
      onRegister && onRegister(auth, '');
    },
    [onRegister],
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Hooks.useSubscriber(session.getManager(AuthenticationManager), (event: RequestAuthEvent) => {
    if (event.type === 'request_auth') {
      openModal(event.mode);
    }
  });

  return (
    <AuthModal
      authMode={authMode}
      isOpen={modalIsOpen}
      onLogin={handleLogin}
      onRegister={handleRegister}
      onRequestClose={closeModal}
      onSessionLoad={handleSessionLoad}
    />
  );
};
